import {BaseApi} from '@/core/api/base.api'
import {Room} from "@/core/api/room.api";
import {roomInviteService} from "@/core/service/room.invite.service";

class RoomInviteApi extends BaseApi {
  constructor() {
    super();
    Room.Invite = this;

    Room.ready(() => {
      this._eventListen(this.#Events);
    });
  }

  #Events = {}

  async inviteByEmail(params) {
    return (await roomInviteService.inviteByEmail(params)).data;
  }

  async checkInvitedEmail(params) {
    return (await roomInviteService.checkInvitedEmail(params)).data;
  }
}

export const roomInviteApi = new RoomInviteApi();
